export const shareableReportInputState = Object.freeze({
  loading: 'loading',
  success: 'success',
  failure: 'failure',
  idle: 'idle',
});
